module.exports = __webpack_public_path__ + "img/slide-details.2ced3f13.svg";